export const getErrorMessage = (error: any, defaultMessage: string = "An error occurred. Please try again."): string => {
    if (!error) return defaultMessage;

    // Handle Axios error response
    if (error.response && error.response.data) {
        const data = error.response.data;

        // Handle string errors (like { "detail": "message" })
        if (typeof data.detail === 'string') {
            return data.detail;
        }

        // Handle field-specific validation errors (like { "is_hot": ["message"] })
        // Return the first error found in any field
        for (const key in data) {
            if (Array.isArray(data[key]) && data[key].length > 0) {
                return data[key][0];
            }
            if (typeof data[key] === 'string') {
                return data[key];
            }
        }
    }

    // Handle generic error message
    if (error.message) {
        return error.message;
    }

    return defaultMessage;
};
